import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsPatientMonthQueryKey({
  personaName,
  month,
  year
}: {
  personaName?: string
  month: number
  year: number
}) {
  return ['operationalCAAMetricsPatientMonth', { personaName, month, year }]
}

export function useOperationalCAAMetricsPatientMonthQuery({
  personaName,
  month,
  year,
  enabled
}: {
  personaName?: string
  month: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsPatientMonthQueryKey({
      personaName,
      month,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsPatientMonth({
        personaName,
        month,
        year
      }),
    enabled
  })
}
